import { Button, Form, Input, message, Radio, Space } from "antd";
import React, { useState } from "react";

// 引入 Antd 的样式（确保项目中已安装 antd）
import "antd/dist/reset.css";

function ShEditor({ onChange, children }) {
  const [form] = Form.useForm();
  const [auditResult, setAuditResult] = useState("agree"); // 默认选中同意

  const handleFinish = (values) => {
    console.log("提交的数据:", values);
    values.result = values.result === 'agree' ? 1 : -1;
    if (values.result === -1 && values.reason === '') {
      return message.error("请输入拒绝理由");
    }
    onChange && onChange(values);
  };

  return (
    <div style={{ padding: "20px", background: "#f9f9f9", borderRadius: 8, minWidth: 500, margin: "20px auto" }}>

      <Form
        form={form}
        layout="vertical" // 垂直布局，标签在输入框上方，更清晰
        onFinish={handleFinish}
        initialValues={{ result: "agree" }} // 设置默认值
      >
        {children}
        {/* 审核结果 */}
        <div style={{ padding: '10px 0' }}><hr style={{ color: "#eee" }} /></div>
        <Form.Item
          label="📝 审核结果"
          name="result"
          rules={[{ required: true, message: "请选择审核结果!" }]}
        >
          <Radio.Group
            onChange={(e) => setAuditResult(e.target.value)}
            style={{ width: "100%", display: "flex", justifyContent: "space-around" }}
          >
            <Radio.Button
              value="agree"
              style={{
                flex: 1,
                textAlign: "center",
                backgroundColor: auditResult === "agree" ? "#e6f7ff" : undefined
              }}
            >
              同意
            </Radio.Button>
            <Radio.Button
              value="reject"
              style={{
                flex: 1,
                textAlign: "center",
                backgroundColor: auditResult === "reject" ? "#fff1f0" : undefined
              }}
            >
              拒绝
            </Radio.Button>
          </Radio.Group>
        </Form.Item>

        {/* 拒绝理由 - 仅在选择拒绝时显示 */}
        <Form.Item
          label="✏️ 审核备注"
          name="reason"
          maxLength={150}
        >
          <Input.TextArea
            rows={4}
            placeholder="可输入备注或拒绝理由"
            showCount
            maxLength={200}
          />
        </Form.Item>

        {/* 操作按钮 */}
        <Form.Item style={{ marginTop: "30px", textAlign: "center" }}>
          <Space>
            <Button onClick={() => form.resetFields()}>重置</Button>
            <Button type="primary" htmlType="submit">
              确定提交
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </div>
  );
}

export default ShEditor;